/**
 * Disable .mh-add-cart-btn click functionality
 * This removes ALL event listeners from PageFly cart buttons
 */

(function() {
  'use strict';
  
  console.log('❌ Disabling .mh-add-cart-btn functionality...');

  function disableButtons() {
    var buttons = document.querySelectorAll('.mh-add-cart-btn');
    console.log('❌ Found ' + buttons.length + ' buttons to disable');

    buttons.forEach(function(btn, index) {
      // Clone the button to remove ALL event listeners
      var newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
      
      // Make it do nothing
      newBtn.style.pointerEvents = 'none';
      newBtn.style.opacity = '0.5';
      newBtn.style.cursor = 'not-allowed';
      
      console.log('❌ Button ' + index + ' disabled');
    });
    
    console.log('❌ All buttons disabled');
  }

  // Run multiple times to catch dynamically loaded buttons
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', disableButtons);
  } else {
    disableButtons();
  }

  // Also run after a delay for PageFly content
  setTimeout(disableButtons, 1000);
  setTimeout(disableButtons, 2000);
  setTimeout(disableButtons, 3000);

})();